export enum StorageKeys {
  TOKEN = 'token',
  REFRESH_TOKEN = 'refreshToken',
  LOGS = 'logs',
  LOG_STATUS = 'log status',
  LOCATIONS = 'locations',
  LOG_LEVEL = 'log level'
}
